import { styled } from "../theme";
export const FormGrid = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
`;
